import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import ListEkloksContainer from "../containers/ekloks/ListEkloksContainer";
import List from "../views/ekloks/ListEkloks";
import DeviceContainer from "../containers/device/DeviceContainer";
import { Fragment } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const EkloksPage = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Ecat">
      <Box p={2}>
        <Box mb="7%">
          <ListEkloksContainer>
            {({
              onConnectDevice,
              content,
              item,
              onCloseDevice,
              onUpdateRowsAndPages,
              updateStatus,
              addAction,
              date,
            }) => (
              <Fragment>
                <List
                  onUpdateRowsAndPages={onUpdateRowsAndPages}
                  onConnectDevice={onConnectDevice}
                  add={addAction}
                  items={
                    content
                      ? content.map((eklok) => ({
                          ...eklok,
                          connected: updateStatus.find(
                            (item) => item.id === eklok.id,
                          )?.connected,
                        }))
                      : []
                  }
                />
                {item ? (
                  <DeviceContainer
                    item={item}
                    onCloseDevice={onCloseDevice}
                    date={date}
                  />
                ) : null}
              </Fragment>
            )}
          </ListEkloksContainer>
        </Box>
      </Box>
    </Page>
  );
};

export default EkloksPage;
